import type { ModelInfo } from "../model.js"

// Baseten
// https://baseten.co/products/model-apis/

export const basetenModels = {
	"moonshotai/Kimi-K2-Thinking": {
		maxTokens: 16_384,
		contextWindow: 262_000,
		supportsImages: false,
		supportsPromptCache: false,
		supportsNativeTools: true,
		inputPrice: 0.6,
		outputPrice: 2.5,
		cacheWritesPrice: 0,
		cacheReadsPrice: 0,
		description: "Kimi K2 Thinking - A model with enhanced reasoning capabilities from Kimi K2",
	},
	"zai-org/GLM-4.6": {
		maxTokens: 16_384,
		contextWindow: 200_000,
		supportsImages: false,
		supportsPromptCache: false,
		supportsNativeTools: true,
		inputPrice: 0.6,
		outputPrice: 2.2,
		cacheWritesPrice: 0,
		cacheReadsPrice: 0,
		description: "Frontier open model with advanced agentic, reasoning and coding capabilities",
	},
	"deepseek-ai/DeepSeek-R1": {
		maxTokens: 16_384,
		contextWindow: 163_840,
		supportsImages: false,
		supportsPromptCache: false,
		supportsNativeTools: true,
		inputPrice: 2.55,
		outputPrice: 5.95,
		cacheWritesPrice: 0,
		cacheReadsPrice: 0,
		description: "DeepSeek's first-generation reasoning model",
	},
	"deepseek-ai/DeepSeek-R1-0528": {
		maxTokens: 16_384,
		contextWindow: 163_840,
		supportsImages: false,
		supportsPromptCache: false,
		supportsNativeTools: true,
		inputPrice: 2.55,
		outputPrice: 5.95,
		cacheWritesPrice: 0,
		cacheReadsPrice: 0,
		description: "The latest revision of DeepSeek's first-generation reasoning model",
	},
	"deepseek-ai/DeepSeek-V3-0324": {
		maxTokens: 16_384,
		contextWindow: 163_840,
		supportsImages: false,
		supportsPromptCache: false,
		supportsNativeTools: true,
		inputPrice: 0.77,
		outputPrice: 0.77,
		cacheWritesPrice: 0,
		cacheReadsPrice: 0,
		description: "Fast general-purpose LLM with enhanced reasoning capabilities",
	},
	"deepseek-ai/DeepSeek-V3.1": {
		maxTokens: 16_384,
		contextWindow: 163_840,
		supportsImages: false,
		supportsPromptCache: false,
		supportsNativeTools: true,
		inputPrice: 0.5,
		outputPrice: 1.5,
		cacheWritesPrice: 0,
		cacheReadsPrice: 0,
		description:
			"Extremely capable general-purpose LLM with hybrid reasoning capabilities and advanced tool calling",
	},
	"deepseek-ai/DeepSeek-V3.2": {
		maxTokens: 16_384,
		contextWindow: 163_840,
		supportsImages: false,
		supportsPromptCache: false,
		supportsNativeTools: true,
		inputPrice: 0.3,
		outputPrice: 0.45,
		cacheWritesPrice: 0,
		cacheReadsPrice: 0,
		description:
			"DeepSeek's hybrid reasoning model with efficient long context scaling with GPT-5 level performance",
	},
	"openai/gpt-oss-120b": {
		maxTokens: 16_384,
		contextWindow: 128_072,
		supportsImages: false,
		supportsPromptCache: false,
		supportsNativeTools: true,
		inputPrice: 0.1,
		outputPrice: 0.5,
		cacheWritesPrice: 0,
		cacheReadsPrice: 0,
		description: "Extremely capable general-purpose LLM with strong, controllable reasoning capabilities",
	},
	"Qwen/Qwen3-235B-A22B-Instruct-2507": {
		maxTokens: 16_384,
		contextWindow: 262_144,
		supportsImages: false,
		supportsPromptCache: false,
		supportsNativeTools: true,
		inputPrice: 0.22,
		outputPrice: 0.8,
		cacheWritesPrice: 0,
		cacheReadsPrice: 0,
		description: "Mixture-of-experts LLM with math and reasoning capabilities",
	},
	"Qwen/Qwen3-Coder-480B-A35B-Instruct": {
		maxTokens: 16_384,
		contextWindow: 262_144,
		supportsImages: false,
		supportsPromptCache: false,
		supportsNativeTools: true,
		inputPrice: 0.38,
		outputPrice: 1.53,
		cacheWritesPrice: 0,
		cacheReadsPrice: 0,
		description: "Mixture-of-experts LLM with advanced coding and reasoning capabilities",
	},
	"moonshotai/Kimi-K2-Instruct-0905": {
		maxTokens: 16_384,
		contextWindow: 262_000,
		supportsImages: false,
		supportsPromptCache: false,
		supportsNativeTools: true,
		inputPrice: 0.6,
		outputPrice: 2.5,
		cacheWritesPrice: 0,
		cacheReadsPrice: 0,
		description: "State of the art language model for agentic and coding tasks. September Update.",
	},
} as const satisfies Record<string, ModelInfo>

export type BasetenModelId = keyof typeof basetenModels

export const basetenDefaultModelId = "zai-org/GLM-4.6" satisfies BasetenModelId
